/**
 * TODO STE-1605: replace this placeholder header with proper JSDoc and a Storybook story
 * WIP
 */
import React from "react";

import { css, cx } from "@emotion/css";
import { UseHoverProps } from "@floating-ui/react";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Optional } from "@/utils/commonUtils.ts";

import { TooltipBase, BaseTooltipProps } from "./TooltipBase.tsx";

const ACTION_FLOATER_MIN_WIDTH_PX = 200;

export type TooltipMenuPropsProps = Omit<Optional<BaseTooltipProps, "role">, "type"> & {
  click?: UseHoverProps;
  openOnHover?: boolean;
};

/**
 * TODO STE-1605 refactor tooltip to be more maintainable
 */
export const TooltipMenu: React.FC<TooltipMenuPropsProps> = ({
  role = "menu",
  click,
  openOnHover = false,
  className,
  floaterClassName,
  wrapperClassName,
  children,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <TooltipBase
      type={openOnHover ? { type: "all", click: click ?? {}, hover: {} } : { type: "click", ...click }}
      role={role}
      className={cx(styles.container, className)}
      wrapperClassName={cx(styles.wrapper, wrapperClassName)}
      floaterClassName={cx(styles.floater, floaterClassName)}
      {...props}
    >
      {children}
    </TooltipBase>
  );
};

export type TooltipMenuActionProps = Omit<Optional<BaseTooltipProps, "role">, "type" | "content"> & {
  click?: UseHoverProps;
  openOnHover?: boolean;
  actions: React.ReactNode;
};

export const TooltipMenuAction: React.FC<TooltipMenuActionProps> = ({
  role = "menu",
  click,
  openOnHover = false,
  className,
  floaterClassName,
  wrapperClassName,
  children,
  actions,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <TooltipBase
      type={openOnHover ? { type: "all", click: click ?? {}, hover: {} } : { type: "click", ...click }}
      role={role}
      className={cx(styles.container, className)}
      wrapperClassName={cx(styles.wrapper, wrapperClassName)}
      floaterClassName={cx(styles.actionFloater, floaterClassName)}
      content={<div className={styles.actions}>{actions}</div>}
      {...props}
    >
      {children}
    </TooltipBase>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css``,
  wrapper: css``,
  floater: css`
    padding: 0;
  `,
  actions: css`
    > * {
      display: flex;
      padding: ${theme.spacing(4)} ${theme.spacing(8)};
      cursor: pointer;

      &:hover {
        background-color: ${theme.palette.background.default};
      }
    }
  `,
  actionFloater: css`
    padding: 0;
    min-width: min(${ACTION_FLOATER_MIN_WIDTH_PX}px, calc(90vw - ${theme.spacing(30)}));
    max-width: calc(90vw - ${theme.spacing(30)});
  `,
});
